import { isEmpty } from 'lodash';
import { InitiateAnalyticsCheck } from './InitiateAnalyticsCheck';
import { GoogleAnalyticTags } from './GoogleAnalyticsTags';

declare const window: any;
export function TriggerGoogleAnalyticsTag(eventAction, eventLabel, data: object | string = '') {

    if (data && !isEmpty(data)) {
        let currentDataKey = Object.keys(data)[0],
            currentDataValue = data[currentDataKey];

        eventLabel = eventLabel.replace('{' + currentDataKey + '}', currentDataValue);
    }

    InitiateAnalyticsCheck(window);

    if (eventAction === GoogleAnalyticTags.eventAction.load) {
        window.isAnalyticsLoaded.then((message) => {
            if (message === "GA-LOADED") {
                window.dataLayer = window.dataLayer || [];
                console.log("OldGatagTriggered",eventLabel);
                window.dataLayer.push(
                    {
                        'event_category': GoogleAnalyticTags.eventCategory,
                        'event_action': eventAction,
                        'event_label': eventLabel, //event_label+dynamicValue,
                        'event': eventAction
                    }
                );
            }
        }).catch((message) => { console.log("In catch", message) });
    } else if (window.ga && window.ga.loaded) {
        window.dataLayer = window.dataLayer || [];
        console.log("OldGatagTriggered",eventLabel);
        window.dataLayer.push(
            {
                'event_category': GoogleAnalyticTags.eventCategory,
                'event_action': eventAction,
                'event_label': eventLabel, //event_label+dynamicValue,
                'event': eventAction
            }
        );
    }
}
